<template>
  <div class="results-list" :aria-busy="isFetching">

    <template v-if="PaginationCond.length > 0">
      <div
        class="results"
        v-for="condamnation in PaginationCond"
        :key="condamnation.id"
      >
        <ul>
          <li class="small meta" v-if="condamnation.Date_infraction">
            Date de l’infraction :
            {{ formatDate(condamnation.Date_infraction) }}
            &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;
          </li>

          <li class="small meta" v-if="condamnation.Date_jugement">
            Date du jugement :
            {{ formatDate(condamnation.Date_jugement) }}
            &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;
          </li>

          <li
            class="small meta"
            v-if="condamnation.SOC_DESC_POURS === 'VILLE DE MONTREAL'"
          >
            Poursuivant : Cour municipale de Montréal
          </li>

          <li
            class="small meta"
            v-else-if="condamnation.SOC_DESC_POURS === 'MAPAQ'"
          >
            Poursuivant : Palais de justice de Québec
          </li>
        </ul>

        <!-- Nom / Raison sociale -->
        <!-- Les deux existent -->
        <hgroup
          v-if="condamnation.Raison_sociale && condamnation.Nom_exploitant"
        >
          <span>{{ condamnation.Nom_exploitant }}</span>
          <h3>{{ condamnation.Raison_sociale }}</h3>
        </hgroup>

        <!-- Seulement Raison_sociale -->
        <hgroup
          v-else-if="condamnation.Raison_sociale"
        >
          <h3>{{ condamnation.Raison_sociale }}</h3>
        </hgroup>

        <!-- Seulement Nom_exploitant -->
        <hgroup
          v-else-if="condamnation.Nom_exploitant"
        >
          <h3>{{ condamnation.Nom_exploitant }}</h3>
        </hgroup>

        <p
          class="petite_majuscule"
          v-if="condamnation.Adresse_lieu_infraction"
        >
          {{ condamnation.Adresse_lieu_infraction }}
        </p>

        <p
          class="petite_majuscule"
          v-if="condamnation.Description_infraction"
        >
          {{ condamnation.Description_infraction }}
        </p>

        <p v-if="condamnation.Amende">
          <strong>Amende : {{ condamnation.Amende }}</strong>
        </p>

        <!-- Information établissement -->
        <div
          v-if="condamnation.Information_etablissement"
          class="mention-precision"
        >
          <p class="etablissementFermer">
            {{ condamnation.Information_etablissement }}
          </p>
        </div>

        <p class="small" v-if="condamnation.Type_etablissement">
          {{ condamnation.Type_etablissement }}
        </p>

        <p class="small" v-if="condamnation.Date_publication">
          Date de publication :
          {{ formatDate(condamnation.Date_publication) }}
        </p>
      </div>
    </template>

    <div v-else class="results-list no-results">
      <div class="results">
        <p>Aucun élément</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Condamnations",

  props: {
    nbrResultats: {
      type: Number,
      required: true
    },
    isFetching: {
      type: Boolean,
      default: false
    },
    condamnations: {
      type: Array,
      default: () => []
    },
    pageCourante: {
      type: Number,
      required: true
    }
  },

  computed: {
    PaginationCond() {
      if (!Array.isArray(this.condamnations)) return []

      const start = (this.pageCourante - 1) * this.nbrResultats
      const end = this.pageCourante * this.nbrResultats

      return this.condamnations.slice(start, end)
    }
  },

  methods: {
    formatDate(date) {
      return date ? date.toString().substring(0, 10) : ""
    }
  }
}
</script>

<style scoped>
</style>
